var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dod"}},[_c('table-view',{attrs:{"end-point":_vm.endPoint,"column-defs":_vm.columnDefs,"filters":_vm.filters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }